import { Injectable, Injector, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { v4 } from 'uuid';
import { LoggerService, LoggerModule } from '@wdpr/ra-angular-logger';
import { CookieService } from 'ngx-cookie-service';

class CorrelationService {
    constructor(cookieService, injector, config) {
        this.cookieService = cookieService;
        this.injector = injector;
        this.config = config;
    }
    logError(message, ...args) {
        const loggerService = this.injector.get(LoggerService);
        loggerService.warn(message, args);
    }
    getConfiguration() {
        return this.config;
    }
    getConversationCookieName() {
        return this.config.wdprConversationCookieName;
    }
    getEndPointFilter() {
        return this.config.wdprEndpointFilter;
    }
    getCookieData(cookieName) {
        return this.cookieService.get(cookieName);
    }
    checkForCookie(cookieName) {
        return this.cookieService.check(cookieName);
    }
    getUuid() {
        return v4();
    }
}
CorrelationService.decorators = [
    { type: Injectable }
];
CorrelationService.ctorParameters = () => [
    { type: CookieService },
    { type: Injector },
    { type: undefined, decorators: [{ type: Inject, args: ['CORRELATION_CONFIG',] }] }
];

class CorrelationInterceptor {
    constructor(correlationService, injector) {
        this.correlationService = correlationService;
        this.injector = injector;
    }
    intercept(request, next) {
        // Determine the attribute names to be used for the CorrelationID and ConversationID
        let conversationUuid;
        const localCorrelationConfig = this.correlationService.getConfiguration();
        const localWdprCorrelationHeader = localCorrelationConfig.wdprCorrelationHeader;
        const localWdprConversationHeader = localCorrelationConfig.wdprConversationHeader;
        const localEndPointFilter = new RegExp(this.correlationService.getEndPointFilter());
        const cookieName = this.correlationService.getConversationCookieName();
        if (this.correlationService.checkForCookie(cookieName)) {
            conversationUuid = this.correlationService.getCookieData(cookieName);
        }
        else {
            this.correlationService.logError('Conversation Id Cookie Not present');
            return next.handle(request);
        }
        const reqObj = {};
        // Remove the base "https://foo.bar/" from the URL"
        const relativeUrl = request.url.replace(/^https?:\/\/.*?\//, '/');
        // If the updated URL matches our filter then do nothing.
        // Do Not Process For Angular Error
        if (!localEndPointFilter.test(relativeUrl)) {
            // Create a new UUID
            reqObj[localWdprCorrelationHeader] = this.correlationService.getUuid();
            // Get the existing Conversation ID
            // (if there is one then use that value instead of the UUID above)
            // If the cookie doesn't exist, then error out to user.
            reqObj[localWdprConversationHeader] = conversationUuid;
            request = request.clone({
                setHeaders: reqObj
            });
        }
        else {
            console.error('Skipping the /error call');
        }
        return next.handle(request);
    }
}
CorrelationInterceptor.decorators = [
    { type: Injectable }
];
CorrelationInterceptor.ctorParameters = () => [
    { type: CorrelationService },
    { type: Injector }
];

const ɵ0 = {
    wdprConversationCookieName: 'Conversation_UUID',
    wdprConversationHeader: 'X-Conversation-Id',
    wdprCorrelationHeader: 'X-Correlation-Id',
    wdprEndpointFilter: '/error/?'
};
/* TODO:
 Add:
  wdpr-ra-angular-error-handler
*/
class CorrelationModule {
}
CorrelationModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    LoggerModule
                ],
                providers: [
                    CorrelationService,
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: CorrelationInterceptor,
                        multi: true,
                        deps: [CorrelationService]
                    },
                    CookieService,
                    {
                        provide: 'CORRELATION_CONFIG',
                        useValue: ɵ0
                    }
                ],
                declarations: [],
                exports: []
            },] }
];

/*
 * Public API Surface of ra-angular-correlation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CorrelationModule, CorrelationService, CorrelationInterceptor as ɵa };
//# sourceMappingURL=wdpr-ra-angular-correlation.js.map
